export function decodeToken(token:string): any {
  try {
    return JSON.parse(atob(token.split('.')[1])).userDetails;
  } catch (e) {
    return {};
  }
}
